<template>
  <div :class="{ content: !$route.meta.hideContent }">
    <!-- error alert start -->
    <div :class="$store.state.errors != ''
        ? 'alert alert-danger text-center p-1 notifications active'
        : ''
      " v-if="$store.state.errors != ''">
      <!-- <b-modal id="modal-error" hide-footer size="lg"> -->
      <button type="button" aria-hidden="true" class="close" @click="$store.state.errors = ''">
        <b-icon font-scale="2" icon="x"></b-icon>
      </button>

      <h4>
        <i class="fas fa-exclamation-triangle"></i>&nbsp;
        {{ Interval() }}
      </h4>
      <p class="text-center">{{ $store.state.errors }}</p>
      <!-- </b-modal> -->
    </div>
    <!-- error alert end -->
    <router-view />
  </div>
</template>
<script>
export default {
  beforecreate: function () {
    // if (this.$store.state.productlist == null) {
    //   if (localStorage.getItem('token') != null) {
    // this.$store.dispatch('Productlist');
    //   }
    // }
    // if(this.$route.path!='/directory/product/index'){
    // if (localStorage['prostatka'] != true) {
    // }
    // }
  },
  mounted: function () {
    if (localStorage["prostatka"] != true || self.$store.state.prostatka) {
      this.Ostatka();
    }
  },
  methods: {
    Ostatka() {
      let self = this;
      var sklad;
      if (localStorage.getItem("sklad_id") > 0) {
        sklad = localStorage.getItem("sklad_id");
      } else {
        sklad = parseInt(localStorage.getItem("sklad_id"));
      }
      var datetime = null;
      if (localStorage.getItem("created_at")) {
        datetime = localStorage.getItem("created_at");
      }
      axios({
        method: "post",
        url: "api/v1/product/all-price-balance/0",
        data: { sklad_id: sklad, datetime: datetime }
      }).then(function (response) {
        localStorage["prostatka"] = true;
        self.$store.state.prostatka = response.data;
      });
    },
    Interval() {
      setTimeout(() => {
        this.$store.state.errors = "";
      }, 3000);
    }
  }
};
</script>
<style scoped>
.notifications {
  z-index: 9999;
  position: absolute;
  top: 0%;
  left: 15%;
  width: 75%;
}
</style>